import Vue from 'vue'
import axios from 'axios'
import Qs from 'qs'
import { sendTiming, sendRequest } from './common'
import { isJSON } from '@common/js/common'
import { interceptRequest } from '@common/js/http'

// post请求时需要将Content-Type设置为'application/x-www-form-urlencode',参数才会以form-data形式提交
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'

// 设置超时时间
axios.defaults.timeout = 2 * 60 * 1000

// 拦截请求，修改请求的配置
axios.interceptors.request.use(
  config => {
    let request_time = Date.now()
    config = interceptRequest(config, Qs)
    // 统计接口用时，发送到ga
    config.transformResponse = data => {
      let response_time = Date.now()
      let cost = response_time - request_time

      let data_format = isJSON(data) ? JSON.parse(data) : data

      sendTiming(
        config.url,
        cost,
        data_format.c === 0 ? 'API Success' : 'API Error',
        JSON.stringify(config.data || config.params || '')
      )

      let url = config.url ? config.url.replace(/((?:\/)\d+)|((?:\?).*)/g, '') : '' // 替换掉url中的id与查询参数
      !!url && sendRequest('Request - ' + location.host, url)

      return data_format
    }

    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 拦截响应
axios.interceptors.response.use(response => {
  let data = response.data
  let code = data.c

  try {
    let config = response.config
    let headers = response.headers
    let cost = Number(headers['x-total-time'])
    sendTiming(
      config.url,
      cost,
      'Server Response',
      JSON.stringify(config.data || config.params || '')
    )
  } catch (e) {}

  switch (code) {
    // 请求成功
    case 0:
      return data.d
    case -3: // 没有权限
      return Promise.reject(data)
    // 登录过期
    case -4:
    case -5:
    case -10:
      window.location = '/api/sso/login'
      return Promise.reject(data)
    default:
      return Promise.reject(data)
  }
})

Object.defineProperties(Vue.prototype, {
  $http: {
    get() {
      return axios
    },
  },
})

export { axios as $http }
